import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import CreateAP from '../../components/AP/CreateAP/createAP';
import { fetchVendors, fetchVendorDetail } from '../../actions/vendors_actions';
import {
  fetchAPInvoices,
  createAP,
  fetchAPCredits,
  clearCredits,
  clearAPDetail,
  changeField,
} from '../../actions/arap_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';

const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);

const validate = (values) => {
  const errors = {};
  if (values.TotalPayment && !isNumeric(values.TotalPayment)) {
    errors.TotalPayment = 'Enter a number!';
  }

  if (values.TotalPayment < 0) {
    errors.TotalPayment = 'Positive numbers only!';
  }

  if (values.Discount && !isNumeric(values.Discount)) {
    errors.Discount = 'Enter a number!';
  }

  if (values.Discount && values.Discount < 0) {
    errors.Discount = 'Positive numbers only!';
  }

  if (values.waiveAmount && !isNumeric(values.waiveAmount)) {
    errors.waiveAmount = 'Enter a number!';
  }

  if (!values.Vendor) {
    errors.Vendor = 'Required';
  }

  if (!values.Account) {
    errors.Account = 'Required';
  }

  if (!values.TotalPayment) {
    errors.TotalPayment = 'Required';
  }

  if (!values.Method) {
    errors.Method = 'Required';
  }

  if (!values.PaymentDate) {
    errors.PaymentDate = 'Required';
  }

  return errors;
};

const createAPForm = reduxForm({
  form: 'createAP',
  destroyOnUnmount: false,
  touchOnChange: true,
  touchOnBlur: false,
  validate,
})(CreateAP);

const selector = formValueSelector('createAP');

function mapStateToProps(state) {
  const vendorID = selector(state, 'Vendor');
  const credits = selector(state, 'Credits');

  const invoiceDate = selector(state, 'InvoiceDate');
  const paymentDate = selector(state, 'PaymentDate');
  const fromDate = selector(state, 'FromDate');
  const toDate = selector(state, 'ToDate');

  const method = selector(state, 'Method');
  const checkNum = selector(state, 'CheckNum');
  const account = selector(state, 'Account');
  const discount = selector(state, 'Discount');
  const totalPayment = selector(state, 'TotalPayment');
  const waiveAmount = selector(state, 'WaiveAmount');
  const note = selector(state, 'Note');

  return {
    vendorID,
    credits,
    invoiceDate,
    paymentDate,
    fromDate,
    toDate,
    method,
    checkNum,
    account,
    discount,
    totalPayment,
    waiveAmount,
    note,
    invoices: state.arap.invoices,
    invoicesIsLoading: state.arap.invoicesIsLoading,
    invoicesError: state.arap.invoicesError,
    apCreated: state.arap.apCreated,
    apCreateError: state.arap.apCreateError,
    apIsCreating: state.arap.apIsCreating,

    // credits: state.arap.credits,
    creditsIsLoading: state.arap.creditsIsLoading,
    creditsError: state.arap.creditsError,

    vendors: state.vendors.all,
    vendorsIsLoading: state.vendors.isLoading,
    vendorsError: state.vendors.error,
    currentVendorDetail: state.vendors.currentVendorDetail,
    userPermissions: state.auth.userPermissions,
  };
}


export default connect(mapStateToProps, {
  fetchAPInvoices,
  createAP,
  fetchVendors,
  fetchVendorDetail,
  fetchAPCredits,
  clearCredits,
  clearAPDetail,
  setDefaultOfForm,
  changeField,
})(createAPForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/AP/createAP.jsx